export const getCompanyName = ({ email }: { email: string }) => {
  let company = /(?<=@)[^.]+(?=\.)/?.exec(email)?.toString();
  if (typeof company !== 'string') return undefined;
  return company?.charAt(0).toUpperCase() + company?.slice(1);
};
